<div class="min-h-screen bg-white flex flex-col">
  <div class="flex-1 container mx-auto max-w-[900px] px-5 py-12">
    <h1 class="text-3xl font-semibold text-gray-800 mb-8">Accessibility</h1>

    <div class="prose prose-gray max-w-none">
      <section class="mb-8">
        <p class="text-gray-600 mb-4">
          Vertical Bridge is committed to ensuring its services are accessible for people with disabilities. The organization has invested substantial resources to make its website more user-friendly and accessible, operating from the principle that all individuals deserve dignity, equality, comfort, and independence.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Access</h2>
        <p class="text-gray-600 mb-4">
          The company provides the UserWay Website Accessibility Widget, which helps improve compliance with Web Content Accessibility Guidelines (WCAG 2.1) standards.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Enabling the Accessibility Menu</h2>
        <p class="text-gray-600 mb-4">
          Users can activate the accessibility menu by pressing the tab key upon page load or clicking the accessibility icon in the page corner. A brief wait is recommended for the menu to fully load.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Disclaimer</h2>
        <p class="text-gray-600 mb-4">
          Vertical Bridge acknowledges ongoing efforts to improve site accessibility. The organization regularly uses UserWay's Accessibility Scanner to identify and address barriers. However, the company notes that some content may not have yet been fully adapted to the strictest accessibility standards due to technological limitations.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Contact Information</h2>
        <p class="text-gray-600 mb-2">
          <strong>Vertical Bridge REIT, LLC</strong>
        </p>
        <p class="text-gray-600 mb-1">22 West Atlantic Avenue, Suite 310</p>
        <p class="text-gray-600 mb-1">Delray Beach, FL 33444</p>
        <p class="text-gray-600">
          Phone: <a href="tel:5619486367" class="text-[#8BC540] hover:underline">(561) 948-6367</a>
        </p>
      </section>
    </div>

    <div class="mt-12 pt-8 border-t border-gray-200">
      <a routerLink="/home" class="text-[#8BC540] hover:underline">&larr; Back to Home</a>
    </div>
  </div>

  <app-footer />
</div>
